import * as Sentry from "@sentry/angular";
import posthog from 'posthog-js'
import { enableProdMode, importProvidersFrom, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';
import { ChunkErrorHandler } from './app/_utils/chunk-error-handler';
import { reducerErrorGuard } from './app/_utils/reducer-error-guard';
import {provideRouter} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import AgloPreset from './agloPreset';
import { calendarFr } from './primeng-calendar-fr';

// import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { MatTreeModule } from '@angular/material/tree';
import { ArtisansSuggestionsService } from './app/_services/artisansSuggestions.service';
import { UserService } from './app/_services/user.service';
import { AcvService } from './app/_services/acv.service';
import { IdentifySegement } from './app/all/segment/identify';
import { ProductsService } from './app/_services/products.service';
import { relatedFichesService } from './app/_services/relatedFiches.service';
import { VariantesService } from './app/_services/variantes.service';
import { ChantierService } from './app/_services/chantier.service';
import { TeamService } from './app/_services/team.service';
import { ArchitectRouteGuard, NewAccountArchitectRouteGuard, ArtisanRouteGuard, ExternalRouteGuard, LoggedRouteGuard, AdminRouteGuard, DemoRouteGuard } from './app/_utils/_guard';
import { ConfirmationService } from 'primeng/api';
import { NotificationsService, SimpleNotificationsModule } from 'angular2-notifications';
import { AuthService, AttributService, ArtisanService, ArchitectService, CeProjectService, CeProjectInvitesService, ErrorService, LogService, DpgfPostesService, CeTaskService, PaymentsService, ArchiDbService } from './app/_services/index';
import { Title, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {routes} from './app/app.routes';
import { LOCALE_ID } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalResponseInterceptorInterceptor } from './app/_utils/_interceptors/global-response-interceptor.interceptor';
import { scrubPosthogEvent, scrubSentryBreadcrumb, scrubSentryEvent } from './app/pages/04-architect/00-profile/offer-activation/activation-token.scrub';

const interceptors: any = [
  { provide: HTTP_INTERCEPTORS, useClass: GlobalResponseInterceptorInterceptor, multi: true }
];
const release = require('../package.json').version;
const isRevitDesktop = navigator.userAgent.includes("Autodesk.Revit/2024");
Sentry.init({
  dsn: "https://6ed7638a187e7de978843c3fadb4ed72@o4509532140273664.ingest.de.sentry.io/4509595661238352",
  release: release,
  sendDefaultPii: true,
  environment: environment.production ? 'production' : 'development',
  enabled: environment.production,
  denyUrls: [
    /embed\.tawk\.to/i,
    /maps\.googleapis\.com/i,
    /public\.profitwell\.com/i,
    /public\.produktly\.com/i,
    /cdn\.amplitude\.com/i,
    /www\.googletagmanager\.com/i,
    /www\.google-analytics\.com/i,
    /www\.google\.com/i,
    /www\.google\.fr/i,
    /www\.google\.com/i,
    /www2\.profitwell\.com/i
  ],
  ignoreErrors: [
    // Produktly widget aborts its own in-flight identifyUser requests via
    // AbortController and leaks the rejection as an unhandledrejection.
    /signal is aborted without reason/i,
    /AbortError/i,
    // Tracker requests blocked by ad blockers; the SDK appends the request host to the message.
    /Failed to fetch \((www2\.profitwell\.com|ad\.doubleclick\.net)\)/i
  ],
  // The activation token of a sales offer (/activation/<token>, /billing/offers/<token>) never reaches Sentry (SALES-16).
  beforeSend: (event) => scrubSentryEvent(event),
  beforeSendTransaction: (event) => scrubSentryEvent(event),
  beforeBreadcrumb: (breadcrumb) => scrubSentryBreadcrumb(breadcrumb)
});

if(environment.production){
  posthog.init(
    'phc_x02FqYfUCRMzrhMFpMX9m5pynP4Jtfvib9PJ4SC1BFz',
    {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2025-11-30',
      // Same masking for PostHog: properties, $set, $set_once and session snapshots (SALES-16).
      before_send: (event) => scrubPosthogEvent(event)
    }
  )
}

declare var Tawk_API
declare var analytics
declare var Produktly
declare global {
  interface Window { // ⚠️ notice that "Window" is capitalized here
    analytics: any;
    prerenderReady: boolean;
    clickRevit : any;
    dispatchWebViewEvent : any;
    Produktly : any;
  }
}
var global = global || window

if (environment.production) {
  enableProdMode();
}


bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        provideAnimationsAsync(),
        providePrimeNG({
            translation: calendarFr,
            theme: {
                preset: AgloPreset,
                options: {
                  darkModeSelector: false,
                  prefix: 'prng'
                }
            }
        }),
        importProvidersFrom(
          CommonModule, 
          RouterModule, 
        //Angular
        BrowserModule, FormsModule, ReactiveFormsModule, 
        //External
        SimpleNotificationsModule.forRoot(), 
        // NgRx
        StoreModule.forRoot({}, {
            metaReducers: [reducerErrorGuard],
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
            }
        }), EffectsModule.forRoot([]), StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true
        })),
        Title,
        //Services
        AuthService,
        AttributService,
        ArtisanService,
        ArchitectService,
        CeProjectService,
        NotificationsService,
        ConfirmationService,
        CeProjectInvitesService,
        ErrorService,
        LogService,
        DpgfPostesService,
        CeTaskService,
        PaymentsService,
        ArchitectRouteGuard,
        AdminRouteGuard,
        DemoRouteGuard,
        NewAccountArchitectRouteGuard,
        ArtisanRouteGuard,
        ExternalRouteGuard,
        LoggedRouteGuard,
        TeamService,
        ChantierService,
        ArchiDbService,
        VariantesService,
        relatedFichesService,
        ProductsService,
        IdentifySegement,
        AcvService,
        UserService,
        ArtisansSuggestionsService,
        MatTreeModule,
        ...interceptors,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        { provide: LOCALE_ID, useValue: 'fr' },
        {
          provide: ErrorHandler,
          useClass: ChunkErrorHandler,
        },
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        {
          provide: APP_INITIALIZER,
          useFactory: () => () => {},
          deps: [Sentry.TraceService],
          multi: true,
        },
    ]
});
//
if(!environment.production){
  console.log("Not Prod");
}
//Start Amplitude Instance
if (environment.production) {
  document.write('<script type="text/javascript">amplitude.getInstance().init("f062ba8ba823f87503b00ecf7eaf753a");</script>');
}
if(!environment.onPremise){
  analytics.load(environment.segmentKey);
}
